import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import setCartPoNumber from "@ucs/Store/Custom/SetCartPoNumber";
import { getCartPoNumberState } from "@ucs/Store/CustomSelectors";
import { CustomState } from "@ucs/Store/Reducers";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {
}

const mapStateToProps = (state: CustomState) => ({
    cartPoNumberState: getCartPoNumberState(state),
    isAuthenticated: state.context.session!.isAuthenticated,
});

const mapDispatchToProps = {
    setCartPoNumber,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface CartPoNumberStyles {
    cartPoNumberTextField?: TextFieldPresentationProps;
}

export const cartPoNumberStyles: CartPoNumberStyles = {
    cartPoNumberTextField: {
        css: css`
            border: red 1px solid;
        `,
    },
};

const styles = cartPoNumberStyles;

const CartPoNumber: React.FC<Props> = ({ cartPoNumberState, setCartPoNumber, isAuthenticated, }) => {
    const [cartPoNumberDisplay, setCartPoNumberDisplay] = React.useState(cartPoNumberState);

    if (!isAuthenticated) {
        return null;
    }

    const poNumberChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        setCartPoNumberDisplay(event.target.value);
        setCartPoNumber({ cartPoNumber: event.target.value });

    };

    return (
        <TextField
            {...styles.cartPoNumberTextField}
            label={translate("PO #")}
            required
            value={cartPoNumberDisplay}
            type="text"
            onChange={poNumberChangeHandler}
        />
    );
};
const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(CartPoNumber),
    definition: {
        group: "Cart",
        icon: "Cart PO Number",
        allowedContexts: ["CartPage"],
    },
};
export default widgetModule;
